// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
import "@stimulus/polyfills";

import { application } from "./application"

// import { eagerLoadControllersFrom } from "@hotwired/stimulus-loading"
// eagerLoadControllersFrom("controllers", application)

import CharacterCounter from '@stimulus-components/character-counter';
application.register('character-counter', CharacterCounter);

import TextareaAutogrow from 'stimulus-textarea-autogrow';
application.register('textarea-autogrow', TextareaAutogrow);

import RemoteRails from '@stimulus-components/remote-rails';
application.register('remote', RemoteRails);

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import BarcodeController from "./barcode_controller"
application.register("barcode", BarcodeController)

import CitiesController from "./cities_controller"
application.register("cities", CitiesController)

import ControllerNameController from "./controller_name_controller"
application.register("controller-name", ControllerNameController)

import ImaskController from "./imask_controller"
application.register("imask", ImaskController)

import InscriptionsController from "./inscriptions_controller"
application.register("inscriptions", InscriptionsController)

import MatriculationsController from "./matriculations_controller"
application.register("matriculations", MatriculationsController)

import PaymentsController from "./payments_controller"
application.register("payments", PaymentsController)

import ViacepController from "./viacep_controller"
application.register("viacep", ViacepController)

import SelectController from "./select_controller";
application.register("select", SelectController);

import step_controller from "./step_controller";
application.register("step", step_controller);

import StepMatriculationController from "./step_matriculation_controller"
application.register("step-matriculation", StepMatriculationController)

import NextInputController from "./next_input_controller"
application.register("next-input", NextInputController)

import EssayController from "./essay_controller";
application.register("essay", EssayController);

import TokenController from "./token_controller";
application.register("token", TokenController);

import LoginController from "./login_controller";
application.register("login", LoginController);

import PaymentController from "./payments_controller";
application.register("payments", PaymentController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import StepBarController from "./stepbar_controller";
application.register("stepbar", StepBarController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);

import LoadingController from "./loading_controller";
application.register("loading", LoadingController);

import EditInscriptionController from "./edit_inscriptions_controller";
application.register("edit-inscriptions", EditInscriptionController);

import AttachementsController from "./attachments_controller";
application.register("attachments", AttachementsController);

import DocumentsController from "./documents_controller";
application.register("documents", DocumentsController);

import CpfController from "./cpf_controller";
application.register("cpf", CpfController);

import ShowMoreController from "./show_more_controller";
application.register("show-more", ShowMoreController);

import GtmController from "./gtm_controller";
application.register("gtm", GtmController);